'use client';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import Link from 'next/link';
import { getFeaturedPrograms } from '@/lib/data/mockData';

const cards = [
  {
    number: '01',
    label: 'Awareness',
    tagline: 'Free · Live · 1 Hour',
    heading: 'Understand what your body is communicating.',
    body: 'A free live session introducing the root-cause framework and your first personalised insight. Begin by seeing clearly — what is blocked, why it stalls, and what is truly possible.',
    href: '/awareness-session',
    cta: 'Join Free Session',
    icon: (
      <svg data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:16:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="16" data-component-end-line="20" data-component-file="PathwaySliderSection.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:17:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="17" data-component-end-line="17" data-component-file="PathwaySliderSection.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="14" cy="14" r="6" stroke="currentColor" strokeWidth="1.5" />
        <circle data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:18:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="18" data-component-end-line="18" data-component-file="PathwaySliderSection.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="1" strokeDasharray="2 3" />
        <circle data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:19:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="19" data-component-end-line="19" data-component-file="PathwaySliderSection.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="14" cy="14" r="2" fill="currentColor" />
      </svg>
    ),
    accent: '#1A6B6B',
    accentLight: 'rgba(26,107,107,0.08)',
    accentBorder: 'rgba(26,107,107,0.28)',
    textAccent: '#1A6B6B',
  },
  {
    number: '02',
    label: 'Implementation',
    tagline: '3 Days · ₹999 · 1 hr/day',
    heading: 'Reset your physical and energetic body.',
    body: 'A focused 3-day course that moves understanding into practice — gut, breath, and energy reset. Feel the shift as your body begins to respond to intentional care.',
    href: '/foundation-course',
    cta: 'Explore Foundation Course',
    icon: (
      <svg data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:36:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="36" data-component-end-line="39" data-component-file="PathwaySliderSection.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:37:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="37" data-component-end-line="37" data-component-file="PathwaySliderSection.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M14 4 L14 24 M4 14 L24 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:38:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="38" data-component-end-line="38" data-component-file="PathwaySliderSection.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M8 8 L20 20 M20 8 L8 20" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.4" />
      </svg>
    ),
    accent: '#1A6B6B',
    accentLight: 'rgba(26,107,107,0.07)',
    accentBorder: 'rgba(26,107,107,0.26)',
    textAccent: '#1A6B6B',
  },
  {
    number: '03',
    label: 'Transformation',
    tagline: '3 Months · Guided · Live',
    heading: 'Deep, guided healing across all dimensions.',
    body: 'The complete program — physical, emotional, and energetic transformation with live sessions and certification. Emerge as someone who has truly healed, not just managed.',
    href: '/transformation-mastery',
    cta: 'Explore Mastery Program',
    icon: (
      <svg data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:55:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="55" data-component-end-line="57" data-component-file="PathwaySliderSection.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:56:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="56" data-component-end-line="56" data-component-file="PathwaySliderSection.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M14 3 L17 11 L26 11 L19 16.5 L21.5 25 L14 20 L6.5 25 L9 16.5 L2 11 L11 11 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
      </svg>
    ),
    accent: '#1A6B6B',
    accentLight: 'rgba(26,107,107,0.07)',
    accentBorder: 'rgba(26,107,107,0.26)',
    textAccent: '#1A6B6B',
  },
];

export default function PathwaySliderSection() {
  const programs = getFeaturedPrograms();
  const sectionRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const [visible, setVisible] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [rowVisible, setRowVisible] = useState<boolean[]>([]);
  const dragStart = useRef(0);
  const dragDelta = useRef(0);

  useEffect(() => {
    const fallback = setTimeout(() => setVisible(true), 400);

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisible(true);
          clearTimeout(fallback);
          programs?.forEach((_, i) => {
            setTimeout(() => {
              setRowVisible(prev => {
                const next = [...prev];
                next[i] = true;
                return next;
              });
            }, 300 + i * 160);
          });
        }
      },
      { threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, [programs]);

  const goTo = useCallback((idx: number) => {
    setActive(Math.max(0, Math.min(cards.length - 1, idx)));
  }, []);

  const onPointerDown = (e: React.PointerEvent) => {
    setIsDragging(true);
    dragStart.current = e.clientX;
    dragDelta.current = 0;
    (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
  };
  const onPointerMove = (e: React.PointerEvent) => {
    if (!isDragging) return;
    dragDelta.current = e.clientX - dragStart.current;
  };
  const onPointerUp = () => {
    if (!isDragging) return;
    setIsDragging(false);
    if (dragDelta.current < -50) goTo(active + 1);
    else if (dragDelta.current > 50) goTo(active - 1);
    dragDelta.current = 0;
  };

  return (
    <section data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:128:4" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="128" data-component-end-line="290" data-component-file="PathwaySliderSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20overflow-hidden%22%7D"
      ref={sectionRef}
      className="relative overflow-hidden"
      style={{
        background: '#F4EFE6',
        paddingTop: 'clamp(5rem, 12vw, 9rem)',
        paddingBottom: 'clamp(6rem, 14vw, 11rem)',
      }}
    >
      {/* Ambient glow */}
      <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:138:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="138" data-component-end-line="143" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%22%7D"
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 30%, rgba(26,107,107,0.06) 0%, transparent 70%)',
        }}
      />

      <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:145:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="145" data-component-end-line="289" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22editorial-container%20relative%20z-10%22%7D" className="editorial-container relative z-10">
        {/* Unified Header */}
        <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:147:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="147" data-component-end-line="179" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%20lg%3Amb-20%22%7D"
          className="text-center mb-16 lg:mb-20"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 0.9s ease, transform 0.9s ease',
          }}
        >
          <p data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:155:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="155" data-component-end-line="160" data-component-file="PathwaySliderSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20font-sans%20uppercase%20tracking-%5B0.22em%5D%20mb-6%20inline-block%22%2C%22textContent%22%3A%22Program%20Architecture%22%7D"
            className="text-xs font-sans uppercase tracking-[0.22em] mb-6 inline-block"
            style={{ color: 'rgba(26,107,107,0.7)' }}
          >
            Program Architecture
          </p>
          <h2 data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:161:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="161" data-component-end-line="172" data-component-file="PathwaySliderSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20text-balance%20mx-auto%22%2C%22textContent%22%3A%22One%20ascending%20path.%22%7D"
            className="font-serif text-balance mx-auto"
            style={{
              fontSize: 'clamp(2rem, 4.5vw, 3.6rem)',
              color: '#1A2828',
              lineHeight: 1.05,
              maxWidth: '22ch',
            }}
          >
            One ascending path.<br data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:170:31" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="170" data-component-end-line="170" data-component-file="PathwaySliderSection.tsx" data-component-name="br" data-component-content="%7B%22elementName%22%3A%22br%22%7D" />
            <span data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:171:12" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="171" data-component-end-line="171" data-component-file="PathwaySliderSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Three%20distinct%20thresholds.%22%7D" style={{ color: 'rgba(36,44,44,0.28)' }}>Three distinct thresholds.</span>
          </h2>
          <p data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:173:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="173" data-component-end-line="178" data-component-file="PathwaySliderSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-light%20leading-relaxed%20text-balance%20mx-auto%20mt-6%22%2C%22textContent%22%3A%22Each%20stage%20builds%20on%20the%20last%20%E2%80%94%20from%20awareness%20to%20action%20to%20lasting%20transformation.%22%7D"
            className="font-sans font-light leading-relaxed text-balance mx-auto mt-6"
            style={{ color: 'rgba(36,44,44,0.42)', fontSize: '0.875rem', maxWidth: '46ch' }}
          >
            Each stage builds on the last — from awareness to action to lasting transformation.
          </p>
        </div>

        {/* Slider Cards */}
        <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:182:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="182" data-component-end-line="268" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20select-none%22%7D"
          ref={trackRef}
          className="relative select-none"
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
          onPointerLeave={onPointerUp}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          {/* Desktop: all 3 cards — inline styles only, no Tailwind */}
          <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:192:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="192" data-component-end-line="220" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Ablock%22%7D" className="hidden lg:block">
            <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:193:12" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="193" data-component-end-line="219" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                justifyContent: 'center',
                alignItems: 'stretch',
                margin: '0 auto',
                width: 'fit-content',
              }}
            >
              {cards.map((card, i) => (
                <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:205:16" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="205" data-component-end-line="217" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  key={card.label}
                  style={{
                    width: '220px',
                    minWidth: '220px',
                    maxWidth: '220px',
                    flexShrink: 0,
                    flexGrow: 0,
                    overflow: 'hidden',
                  }}
                >
                  <SliderCard data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:216:18" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="216" data-component-end-line="216" data-component-file="PathwaySliderSection.tsx" data-component-name="SliderCard" data-component-content="%7B%22elementName%22%3A%22SliderCard%22%7D" card={card} index={i} visible={visible} isActive={true} />
                </div>
              ))}
            </div>
          </div>

          {/* Mobile slider */}
          <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:223:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="223" data-component-end-line="246" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Ahidden%22%7D" className="lg:hidden" style={{ overflow: 'hidden', width: '100%' }}>
            <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:224:12" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="224" data-component-end-line="245" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              style={{
                display: 'flex',
                width: `${cards.length * 100}%`,
                transform: `translateX(calc(-${active * (100 / cards.length)}%))`,
                transition: isDragging ? 'none' : 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              {cards.map((card, i) => (
                <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:233:16" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="233" data-component-end-line="243" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  key={card.label}
                  style={{
                    width: `${100 / cards.length}%`,
                    flexShrink: 0,
                    boxSizing: 'border-box',
                    padding: '0 12px',
                  }}
                >
                  <SliderCard data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:242:18" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="242" data-component-end-line="242" data-component-file="PathwaySliderSection.tsx" data-component-name="SliderCard" data-component-content="%7B%22elementName%22%3A%22SliderCard%22%7D" card={card} index={i} visible={visible} isActive={i === active} />
                </div>
              ))}
            </div>
          </div>

          {/* Mobile dots */}
          <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:249:10" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="249" data-component-end-line="267" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Ahidden%20flex%20justify-center%20gap-3%20mt-8%22%7D" className="lg:hidden flex justify-center gap-3 mt-8">
            {cards.map((_, i) => (
              <button data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:251:14" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="251" data-component-end-line="265" data-component-file="PathwaySliderSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={i}
                onClick={() => goTo(i)}
                aria-label={`Go to slide ${i + 1}`}
                style={{
                  width: i === active ? '28px' : '8px',
                  height: '8px',
                  borderRadius: '4px',
                  background: i === active ? cards[active].accent : 'rgba(36,44,44,0.15)',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.35s ease',
                  padding: 0,
                }}
              />
            ))}
          </div>
        </div>

        {/* Desktop label nav */}
        <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:271:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="271" data-component-end-line="288" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20justify-center%20gap-4%20mt-12%22%7D" className="hidden lg:flex justify-center gap-4 mt-12">
          {cards.map((card, i) => (
            <button data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:273:12" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="273" data-component-end-line="286" data-component-file="PathwaySliderSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22font-sans%20text-xs%20uppercase%20tracking-%5B0.14em%5D%20px-4%20py-2%20rounded-full%22%7D"
              key={card.label}
              onClick={() => goTo(i)}
              className="font-sans text-xs uppercase tracking-[0.14em] px-4 py-2 rounded-full"
              style={{
                background: 'transparent',
                border: `1px solid ${i === active ? card.accent : 'rgba(36,44,44,0.12)'}`,
                color: i === active ? card.accent : 'rgba(36,44,44,0.35)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              {card.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

interface CardData {
  number: string;
  label: string;
  tagline: string;
  heading: string;
  body: string;
  href: string;
  cta: string;
  icon: React.ReactNode;
  accent: string;
  accentLight: string;
  accentBorder: string;
  textAccent: string;
}

function SliderCard({
  card,
  index,
  visible,
  isActive,
}: {
  card: CardData;
  index: number;
  visible: boolean;
  isActive: boolean;
}) {
  const [hovered, setHovered] = useState(false);

  return (
    <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:323:4" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="323" data-component-end-line="447" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        background: hovered ? card.accentLight : 'rgba(255,255,255,0.55)',
        border: `1px solid ${hovered ? card.accentBorder : 'rgba(36,44,44,0.08)'}`,
        borderRadius: '16px',
        padding: '1.1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.85rem',
        cursor: 'default',
        opacity: visible ? (isActive ? 1 : 0.85) : 0,
        transform: visible
          ? hovered
            ? 'translateY(-4px) scale(1.012)'
            : 'translateY(0) scale(1)'
          : `translateY(36px) scale(0.97)`,
        transition: `opacity 0.75s ease ${index * 0.15}s, transform ${hovered ? '0.35s ease' : `0.75s ease ${index * 0.15}s`}, background 0.3s ease, border-color 0.3s ease, box-shadow 0.35s ease`,
        boxShadow: hovered
          ? `0 14px 40px rgba(36,44,44,0.12), 0 0 0 1px ${card.accentBorder}`
          : '0 4px 16px rgba(36,44,44,0.06)',
        minHeight: '260px',
      }}
    >
      {/* Top row: number + icon */}
      <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:351:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="351" data-component-end-line="374" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20justify-between%22%7D" className="flex items-start justify-between">
        <span data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:352:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="352" data-component-end-line="363" data-component-file="PathwaySliderSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-serif%22%7D"
          className="font-serif"
          style={{
            fontSize: '2rem',
            lineHeight: 1,
            color: hovered ? card.accent : 'rgba(36,44,44,0.12)',
            transition: 'color 0.35s ease',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {card.number}
        </span>
        <span data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:364:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="364" data-component-end-line="373" data-component-file="PathwaySliderSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
          style={{
            color: hovered ? card.accent : 'rgba(36,44,44,0.3)',
            transition: 'color 0.35s ease, transform 0.35s ease',
            transform: hovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)',
            display: 'inline-flex',
          }}
        >
          {card.icon}
        </span>
      </div>

      {/* Label + tagline */}
      <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:377:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="377" data-component-end-line="390" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
        <p data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:378:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="378" data-component-end-line="383" data-component-file="PathwaySliderSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-semibold%20text-xs%20uppercase%20tracking-%5B0.16em%5D%20mb-1%22%7D"
          className="font-sans font-semibold text-xs uppercase tracking-[0.16em] mb-1"
          style={{ color: card.textAccent, opacity: hovered ? 1 : 0.75, transition: 'opacity 0.3s ease' }}
        >
          {card.label}
        </p>
        <p data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:384:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="384" data-component-end-line="389" data-component-file="PathwaySliderSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20text-xs%22%7D"
          className="font-sans text-xs"
          style={{ color: 'rgba(36,44,44,0.38)' }}
        >
          {card.tagline}
        </p>
      </div>

      {/* Divider */}
      <div data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:393:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="393" data-component-end-line="399" data-component-file="PathwaySliderSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        style={{
          height: '1px',
          background: hovered ? card.accentBorder : 'rgba(36,44,44,0.07)',
          transition: 'background 0.35s ease',
        }}
      />

      {/* Heading */}
      <h3 data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:402:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="402" data-component-end-line="412" data-component-file="PathwaySliderSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-serif%20text-balance%22%7D"
        className="font-serif text-balance"
        style={{
          fontSize: 'clamp(0.9rem, 1.3vw, 1.1rem)',
          color: '#1A2828',
          lineHeight: 1.3,
          flex: 1,
        }}
      >
        {card.heading}
      </h3>

      {/* Body */}
      <p data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:415:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="415" data-component-end-line="424" data-component-file="PathwaySliderSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-light%20leading-relaxed%22%7D"
        className="font-sans font-light leading-relaxed"
        style={{
          fontSize: '0.78rem',
          color: 'rgba(36,44,44,0.45)',
          lineHeight: 1.65,
        }}
      >
        {card.body}
      </p>

      {/* CTA */}
      <Link data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:427:6" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="427" data-component-end-line="446" data-component-file="PathwaySliderSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20font-sans%20font-medium%20text-sm%20mt-auto%22%7D"
        href={card.href}
        className="inline-flex items-center gap-2 font-sans font-medium text-sm mt-auto"
        style={{
          color: hovered ? card.accent : 'rgba(36,44,44,0.38)',
          transition: 'color 0.3s ease',
          textDecoration: 'none',
        }}
        onMouseEnter={e => {
          const arrow = e.currentTarget.querySelector('span');
          if (arrow) (arrow as HTMLElement).style.transform = 'translateX(5px)';
        }}
        onMouseLeave={e => {
          const arrow = e.currentTarget.querySelector('span');
          if (arrow) (arrow as HTMLElement).style.transform = 'translateX(0)';
        }}
      >
        {card.cta}
        <span data-component-id="src/app/homepage/components/PathwaySliderSection.tsx:445:8" data-component-path="src/app/homepage/components/PathwaySliderSection.tsx" data-component-line="445" data-component-end-line="445" data-component-file="PathwaySliderSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%86%92%22%7D" style={{ display: 'inline-block', transition: 'transform 0.25s ease' }}>→</span>
      </Link>
    </div>
  );
}
